import { IResponsiveSettings, IEnabler } from '../interfaces/IProdcat';
import { ComponentTypes } from '../constants/ComponentTypes';

type CONFIG = {
    prodcatConfig?: object;
};

export const mergeConfigs = (stateConfig: CONFIG, propsConfig: CONFIG) => {
    const { prodcatConfig = {}, ...restOfStateConfig } = stateConfig;
    const { prodcatConfig: prodcatPropsConfigs, ...restOfPropsConfig } = propsConfig;

    return {
        ...prodcatConfig,
        ...prodcatPropsConfigs,
        ...restOfStateConfig,
        ...restOfPropsConfig
    };
};

type CTA_CONFIG = {
    selectedSku?: {
        skuId: string;
    };
    skuId: string;
};

export const mergeProductCTAConfigs = (stateConfig: CTA_CONFIG, propsConfig: CTA_CONFIG) => {
    const config = {
        ...stateConfig,
        ...propsConfig
    };

    const { selectedSku, skuId } = config;

    return {
        ...config,
        skuId: skuId || (selectedSku && selectedSku.skuId)
    };
};

export const getResponsiveConfig = (
    breakpoint: number,
    responsiveSettings?: IResponsiveSettings[]
) => {
    const responsiveConfig =
        responsiveSettings &&
        responsiveSettings.find((responsive) => responsive.breakpoint === breakpoint);

    return responsiveConfig && responsiveConfig.settings;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getConfigOverrides = (config: any = {}, componentType?: ComponentTypes) => {
    const { overrides, ...rootConfig } = config;

    const configOverrides = overrides && componentType && overrides[componentType];

    return { ...rootConfig, ...configOverrides };
};

export const isEnabled = (configKey?: IEnabler): boolean => {
    return Boolean(configKey && configKey.enabled);
};
